import { render, staticRenderFns } from "./regulationsCheck.vue?vue&type=template&id=1afeadb9&scoped=true&"
import script from "./regulationsCheck.vue?vue&type=script&lang=js&"
export * from "./regulationsCheck.vue?vue&type=script&lang=js&"
import style0 from "./regulationsCheck.vue?vue&type=style&index=0&id=1afeadb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afeadb9",
  null
  
)

export default component.exports